import { RowModel } from "@tanstack/react-table";
import { IPart, IPartCategory } from "../../../models/Part";
import useDefaultCRUDHandlers from "../../../hooks/useDefaultCRUDHandlers";
import useNotification from "../../notifications/useNotifications";
import useCategories from "../../../data/useCategories";
import { useState } from "react";
import Modal from "../../../layouts/Modal";
import { ButtonInput } from "../../shared/Inputs/ButtonInput";
import LoadingWheel from "../../shared/LoadingWheel";
import SelectInput from "../../shared/Inputs/SelectInput";
import { useForm } from "react-hook-form";
import PartCategoryCombo from "../../leads/LeadParts/PartCategoryCombo";
import { XMarkIcon } from "@heroicons/react/24/outline";


export default function ChangeCategoryModal({ open, setOpen, setToUpdate, parts }:
  {
    open: boolean,
    setOpen: React.Dispatch<React.SetStateAction<boolean>>,
    setToUpdate: React.Dispatch<React.SetStateAction<RowModel<IPart> | undefined>>,
    parts: IPart[]
  }) {
  const { register, setValue, getValues, watch } = useForm();
  const { addNotification } = useNotification();
  const { categories, bulkUpdatePartCategories } = useCategories();
  const [categoryUpdate, setCategoryUpdate] = useState<IPartCategory | undefined>(undefined);


  const handleChangeCategory = () => {

    if (!categoryUpdate) {
      addNotification({
        primaryText: "Could not find category",
        variant: "error",
      });
      return;
    };

    const partIds = parts.map(part => part.id);

    const body = {
      categoryId: categoryUpdate.id,
      parts: partIds,
    };

    bulkUpdatePartCategories.mutate(body, {
      onSuccess: () => {
        addNotification({
          primaryText: "Parts updated successfully",
          variant: "success",
        });
        setToUpdate(undefined);
        setCategoryUpdate(undefined);
        setOpen(false);
      },
      onError: (error) => {
        addNotification({
          primaryText: "Error moving parts",
          variant: "error",
        });
      }
    });
  };

  return (
    <Modal open={open} width={"max-w-6xl"} setOpen={setOpen}>
      <div className="space-y-4">
        <p>You are about to update {parts?.length} parts!</p>
        <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-2">

          {categories.isLoading ? (
            <LoadingWheel />
          ) : (
            <div className="flex items-center w-full max-w-96 gap-x-2">
              <PartCategoryCombo handleAddCategory={(category: any) => setCategoryUpdate(category)} placeholder={categoryUpdate?.name ?? "Start Typing to Search for a Category"} />
              <XMarkIcon className="h-5 w-5 mt-5 text-red-600 cursor-pointer" onClick={() => setCategoryUpdate(undefined)} />
            </div>
          )}


          <div className="w-full mt-7">
            <ButtonInput label={"Update All"} classes={"w-full "} onClick={handleChangeCategory} isLoading={bulkUpdatePartCategories.isLoading} />
          </div>
        </div>
      </div>
    </Modal>
  )
};